import { combineReducers } from 'redux';
import user from './user';
import session from './session';
import messages from './messages';
import accounts from './accounts';
import streams from './streams';
export default combineReducers({
    user,
    session,
    messages,
    accounts,
    streams
})


// WEBPACK FOOTER //
// ./src/modules/index.js